import { useDisclosure } from "@chakra-ui/react";
import React from "react";
import PatientSyncVisitsAddressModal from "../../../modules/patient/components/PatientSyncVisitsAddressModal";
import { useReactBridgeDispatchEvent } from "../../hooks/useReactBridgeEvent";
import { PatientId } from "../../schema/schema";

export default function SyncPatientVisitsAddressModalListener() {
  const disclosure = useDisclosure();
  const [patientId, setPatientId] = React.useState<PatientId | undefined>(undefined);

  useReactBridgeDispatchEvent({
    eventName: "PATIENT:OPEN_SYNC_VISITS_ADDRESS",
    onEvent: ({ patientId }) => {
      setPatientId(patientId);
      disclosure.onOpen();
    },
  });

  if (patientId === undefined) {
    return <></>;
  }

  return <PatientSyncVisitsAddressModal disclosure={disclosure} patientId={patientId} />;
}
